{
  "page": { "title": "Revenue report", "subtitle": "{{count}} settled orders in range" },
  "column": {
    "settle_time": "Settle date",
    "order_no": "Order no",
    "marketplace": "Marketplace",
    "seller_name": "Seller",
    "currency": "Currency",
    "gross": "Gross",
    "fees": "Fees",
    "net": "Net",
    "packages": "Packages"
  },
  "kpi": {
    "orders": "Orders",
    "gross": "Gross",
    "fees": "Fees",
    "net": "Net"
  },
  "toolbar": {
    "search_placeholder": "Search order no…",
    "date_from": "From",
    "date_to": "To",
    "marketplace": "Marketplace",
    "all_marketplaces": "All marketplaces"
  },
  "state": {
    "empty": "No settled orders in this range.",
    "error": "Could not load the revenue report.",
    "none": "—"
  }
}
